import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ onGetQuoteClick }) => {
  const [staircaseHovered, setStaircaseHovered] = useState(null);
  const [liftHovered, setLiftHovered] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileStaircaseOpen, setMobileStaircaseOpen] = useState(false);
  const [mobileLiftOpen, setMobileLiftOpen] = useState(false);

  const staircaseOptions = [
    {
      id: 'curved',
      route: 'curved_stair',
      title: 'Curved Staircase',
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/a4d2ac80-f05c-4244-bbb6-3ed5c92a765c.webp',
      heading: 'Curved Stairlifts',
      description: 'Perfectly fitted for complex turns'
    },
    {
      id: 'straight',
      route: 'straight_stair',
      title: 'Straight Staircase',
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/d066306d-8e02-435c-98ce-6615545a7294.webp',
      heading: 'Straight Stairlifts',
      description: 'Efficient and elegant straight runs'
    },
    {
      id: 'platform',
      route: 'floating_stair',
      title: 'Floating Stair',
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/be9ec1dc-726d-49a6-aa4f-97b404286330.webp',
      heading: 'Floating Stair',
      description: 'a stunning architectural feature that seamlessly combines beauty and practicality'
    }
  ];

  const liftOptions = [
    {
      id: 'residential',
      route: 'pro_series',
      title: 'Pro Series',
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/af029fcf-8fdf-4ac4-9162-961e10e9dd3d.webp',
      heading: 'Pro Series',
      description: 'Quiet Intelligence, Comfortable Companionship'
    },
    {
      id: 'commercial',
      route: 'panoramic_series',
      title: 'Panoramic Series',
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/1c07fa94-1edc-4f88-9f08-378b6d7c7bb5.webp',
      heading: 'Panoramic Series',
      description: 'A distinct vista on every level, a world of views'
    },
    {
      id: 'panoramic',
      route: 'mini_series',
      title: 'Mini Series',
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/7454d717-30df-400f-9d10-25dbce20ca09.webp',
      heading: 'Mini Series',
      description: 'Ultimate Space, Limitless Possibilities'
    },
    {
      id: 'freight',
      route: 'classies_series',
      title: 'Classies Series',
      image: 'https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/dd9dd189-709b-4e4b-ae23-030052c6e4f6.webp',
      heading: 'Classies Series',
      description: 'Intelligence at your fingertips. Serenity in your home.'
    }
  ];

  const isDesktopDropdownOpen = !!staircaseHovered || !!liftHovered;

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2 sm:space-x-3">
            <img 
              src="/images/logo.png" 
              alt="StairLifté Logo" 
              className="w-12 h-12 sm:w-16 sm:h-16 lg:w-[5rem] lg:h-[5rem] object-contain"
            />
            <div>
              <div className="font-display text-lg sm:text-xl lg:text-2xl font-bold text-premium-dark tracking-tight">
                StairLifté
              </div>
              <div className="text-[10px] sm:text-xs text-gray-500 tracking-widest">LIFT & STAIRCASE</div>
            </div>
          </Link>
          <div className="hidden lg:flex items-center space-x-10">
            <div
              className="group"
              onMouseEnter={() => setStaircaseHovered('default')}
              onMouseLeave={() => setStaircaseHovered(null)}>
              <span className="text-[0.9625rem] font-medium text-premium-dark hover:text-premium-gold transition-colors flex items-center h-20 cursor-pointer">
                Staircase{' '}
                <i
                  className={`fa-solid fa-chevron-${staircaseHovered ? 'up' : 'down'} ml-2 text-[0.825rem] transition-transform duration-200`}
                ></i>
              </span>
              <div
                className={`fixed left-1/2 top-20 -translate-x-1/2 w-[792px] bg-white shadow-2xl border border-gray-100 transition-all duration-300 rounded-b-lg overflow-hidden ${
                  staircaseHovered ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-2 pointer-events-none'
                } z-50`}
              >
                <div className="flex h-[440px]">
                  <div className="w-1/2 p-8 flex flex-col space-y-1 bg-white z-10">
                    {staircaseOptions.map((option) => (
                      <Link
                        key={option.id}
                        to={`/${option.route}`}
                        className="py-3 px-4 transition-all duration-300 cursor-pointer"
                        onMouseEnter={() => setStaircaseHovered(option.id)}
                        onClick={() => setStaircaseHovered(null)}
                      >
                        <h4 className="text-premium-dark text-[0.9625rem] font-medium whitespace-nowrap transition-all duration-300 hover:text-premium-gold hover:font-bold">
                          {option.title}
                        </h4>
                      </Link>
                    ))}
                  </div>
                  <div className="w-1/2 relative bg-premium-light">
                    <div className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${staircaseHovered === 'default' || staircaseHovered === null ? '' : 'hidden'}`}>
                      <img
                        src="https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/2a4d8991-4dca-44ae-96ee-5b4bb39b5eb1.webp"
                        alt="Luxury staircase collection showcase"
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-premium-dark/80 via-transparent to-transparent flex items-end p-8">
                        <p className="text-white font-display text-2xl font-light">
                          Explore our Staircase Solution
                        </p>
                      </div>
                    </div>
                    {staircaseOptions.map((option) => (
                      <div
                        key={option.id}
                        className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${staircaseHovered === option.id ? '' : 'hidden'}`}
                      >
                        <img
                          src={option.image}
                          alt={option.title}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-premium-dark/80 via-transparent to-transparent flex items-end p-8">
                          <div>
                            <h3 className="text-white font-display text-2xl font-bold">
                              {option.heading}
                            </h3>
                            <p className="text-gray-200 text-base mt-2 font-light">
                              {option.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div
              className="group"
              onMouseEnter={() => setLiftHovered('default')}
              onMouseLeave={() => setLiftHovered(null)}>
              <span className="text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors flex items-center h-20 cursor-pointer">
                Lift{' '}
                <i
                  className={`fa-solid fa-chevron-${liftHovered ? 'up' : 'down'} ml-2 text-[0.825rem] transition-transform duration-200`}
                ></i>
              </span>
              <div
                className={`fixed left-1/2 top-20 -translate-x-1/2 w-[792px] bg-white shadow-2xl border border-gray-100 transition-all duration-300 rounded-b-lg overflow-hidden ${
                  liftHovered ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible translate-y-2 pointer-events-none'
                } z-50`}
              >
                <div className="flex h-[440px]">
                  <div className="w-1/2 p-8 flex flex-col space-y-1 bg-white z-10">
                    {liftOptions.map((option) => (
                      <Link
                        key={option.id}
                        to={`/${option.route}`}
                        className="py-3 px-4 transition-all duration-300 cursor-pointer"
                        onMouseEnter={() => setLiftHovered(option.id)}
                        onClick={() => setLiftHovered(null)}
                      >
                        <h4 className="text-premium-dark text-[0.9625rem] font-medium whitespace-nowrap transition-all duration-300 hover:text-premium-gold hover:font-bold">
                          {option.title}
                        </h4>
                      </Link>
                    ))}
                  </div>
                  <div className="w-1/2 relative bg-premium-light">
                    <div className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${liftHovered === 'default' || liftHovered === null ? '' : 'hidden'}`}>
                      <img
                        src="https://assets.storydoc.com/13c8efe3fa4882546678ec6b4c38fb70/b896f157-303e-49df-acdf-acd1dc3bcc77.webp"
                        alt="Luxury elevator collection showcase"
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-premium-dark/80 via-transparent to-transparent flex items-end p-8">
                        <p className="text-white font-display text-2xl font-light">
                          Discover our Lift Collections
                        </p>
                      </div>
                    </div>
                    {liftOptions.map((option) => (
                      <div
                        key={option.id}
                        className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${liftHovered === option.id ? '' : 'hidden'}`}
                      >
                        <img
                          src={option.image}
                          alt={option.title}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-premium-dark/80 via-transparent to-transparent flex items-end p-8">
                          <div>
                            <h3 className="text-white font-display text-2xl font-bold">
                              {option.heading}
                            </h3>
                            <p className="text-gray-200 text-base mt-2 font-light">
                              {option.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

         
            <a href="/#projects" className="text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors">
              Projects
            </a>
            <a href="/#partnerships" className="text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors">
              Partnerships
            </a>
            <a href="/#contact" className="text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors">
              Contact
            </a>
          </div>
          <div className="flex items-center space-x-2 sm:space-x-4">
          
            <button 
              onClick={() => onGetQuoteClick && onGetQuoteClick()}
              className="bg-premium-gold text-white px-3 py-2 sm:px-6 sm:py-3 text-sm sm:text-[0.9625rem] font-medium hover:bg-premium-gray hover:text-premium-gold transition-colors"
            >
              Get Quote
            </button>
            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-premium-dark p-2"
              aria-label="Toggle menu"
            >
              <i className={`fa-solid ${mobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden border-t border-gray-100 bg-white transition-all duration-300 overflow-hidden ${
          mobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="py-4 space-y-2">
            {/* Staircase Mobile Menu */}
            <div>
              <button
                onClick={() => setMobileStaircaseOpen(!mobileStaircaseOpen)}
                className="w-full flex items-center justify-between px-4 py-3 text-[0.9625rem] font-medium text-premium-dark hover:text-premium-gold transition-colors"
              >
                <span>Staircase</span>
                <i className={`fa-solid fa-chevron-${mobileStaircaseOpen ? 'up' : 'down'} text-xs`}></i>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${
                mobileStaircaseOpen ? 'max-h-96' : 'max-h-0'
              }`}>
                {staircaseOptions.map((option) => (
                  <Link
                    key={option.id}
                    to={`/${option.route}`}
                    onClick={() => { setMobileMenuOpen(false); setMobileStaircaseOpen(false); }}
                    className="block px-8 py-2 text-sm text-gray-600 hover:text-premium-gold hover:bg-premium-light transition-colors"
                  >
                    {option.title}
                  </Link>
                ))}
              </div>
            </div>

            {/* Lift Mobile Menu */}
            <div>
              <button
                onClick={() => setMobileLiftOpen(!mobileLiftOpen)}
                className="w-full flex items-center justify-between px-4 py-3 text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors"
              >
                <span>Lift</span>
                <i className={`fa-solid fa-chevron-${mobileLiftOpen ? 'up' : 'down'} text-xs`}></i>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${
                mobileLiftOpen ? 'max-h-96' : 'max-h-0'
              }`}>
                {liftOptions.map((option) => (
                  <Link
                    key={option.id}
                    to={`/${option.route}`}
                    onClick={() => { setMobileMenuOpen(false); setMobileLiftOpen(false); }}
                    className="block px-8 py-2 text-sm text-gray-600 hover:text-premium-gold hover:bg-premium-light transition-colors"
                  >
                    {option.title}
                  </Link>
                ))}
              </div>
            </div>

            {/* Other Links */}
            <Link to="/projects"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-3 text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors"
            >
              Projects
            </Link>
            <a href="/#partnerships"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-3 text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors"
            >
              Partnerships
            </a>
            <a href="/#contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-4 py-3 text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors"
            >
              Contact
            </a>
            <a
              href="tel:0403708601"
              className="block px-4 py-3 text-[0.9625rem] font-medium text-gray-600 hover:text-premium-gold transition-colors lg:hidden"
            >
              <i className="fa-solid fa-phone mr-2"></i>0403708601
            </a>
          </div>
        </div>
      </div>
      </nav>

      {/* Glassmorphism overlay when desktop dropdown is open */}
      {isDesktopDropdownOpen && (
        <div className="fixed inset-0 z-40 bg-white/10 backdrop-blur-md transition-opacity duration-300 pointer-events-none" />
      )}
    </>
  );
};

export default Header;
